<template>
    <div class="VariablesForm">
        <div class="centerY variable-item" v-for="(variable, index) in variableList" :key="index">
            <div style="flex: 1" class="mr-6">
                <v-text-field
                    outlined
                    v-model="variable.variable"
                    :placeholder="$f.tc('enterVariable')"
                    class="input-custom"
                    :readonly="readonly"
                    @blur="emitNewVariableList"
                ></v-text-field>
            </div>
            <div style="width: 15px" class="mr-6 operator">=</div>
            <div style="flex: 1" :class="readonly ? '' : 'mr-6'">
                <v-text-field
                    outlined
                    v-model="variable.value"
                    :placeholder="$f.tc('enterValue')"
                    class="input-custom"
                    :readonly="readonly"
                    @blur="emitNewVariableList"
                ></v-text-field>
            </div>
            <div class="btn-icon" @click="deleteVariable(variable)" v-if="!readonly">
                <img src="/img/delete-blue.svg" alt="icon-delete-variable" style="transform: scale(1.2)">
            </div>
        </div>
        <div v-if="readonly && variableList.length === 0" style="font-size: 14px; color: #96add0">
            {{ $f.tc('noDataAvailable') }}
        </div>
        <div v-if="!readonly">
            <div class="centerY">
                <div style="flex: 1" class="mr-6">
                    <v-text-field
                        outlined
                        v-model="newVariable.variable"
                        :placeholder="$f.tc('enterVariable')"
                        class="input-custom"
                    ></v-text-field>
                </div>
                <div style="width: 15px" class="mr-6 operator">=</div>
                <div style="flex: 1" class="mr-6">
                    <v-text-field
                        outlined
                        v-model="newVariable.value"
                        :placeholder="$f.tc('enterValue')"
                        @keypress.enter="addVariable"
                        class="input-custom"
                    ></v-text-field>
                </div>
                <div class="btn-icon" @click="addVariable">
                    <img src="/img/add-blue.svg" alt="icon-add-variable" style="transform: scale(1.3)">
                </div>
            </div>
            <div v-if="message" class="mt-6" style="color: red; font-size: 13px; font-family: 'open sans'">
                {{ message }}
            </div>
        </div>
    </div>
</template>

<script>
import ScenarioService from '@/services/scenario.service'
import lodash from 'lodash'

const { OperatorList } = ScenarioService

export default {
    name: 'VariablesForm',
    props: {
        value: Object,
        readonly: {
            type: Boolean,
            default: false
        },
        config: Object,
    },
    data () {
        return {
            OperatorList,
            variableList: [],
            newVariable: {
                variable: '',
                value: ''
            },
            message: '',
            newVariableList: []
        }
    },
    mounted () {
        this.convertDataToPreview()
    },
    methods: {
        convertDataToPreview () {
            let keys = Object.keys(this.value)
            let arrVar = []
            keys.forEach(key => {
                arrVar.push({
                    variable: key,
                    value: this.value[key]
                })
            })
            this.variableList = arrVar
        },
        convertArrayToMap () {
            let dataMap = {}
            this.variableList.forEach(item => {
                dataMap[item.variable] = item.value
            })
            return dataMap
        },
        addVariable () {
            if (!this.newVariable.variable || !this.newVariable.value) {
                this.message = this.$f.tc('pleaseEnterAllFields')
                return
            }
            if (this.variableList.find(i => i.variable === this.newVariable.variable)) {
                this.message = this.$t('formRules.fieldDuplicate')
                return
            }
            this.message = ''
            this.variableList.push(this.newVariable)
            this.emitNewVariableList()
            this.newVariable = {
                variable: '',
                value: ''
            }
        },
        deleteVariable (item) {
            this.$appService.confirm(this.$t('confirmDelete', { item: this.$t('variable') })).then(
                () => {
                    // demo
                    let idx = this.variableList.findIndex(i => lodash.isEqual(i, item))
                    if (idx > -1) {
                        this.variableList.splice(idx, 1)
                        this.emitNewVariableList()
                        this.$forceUpdate()
                    }
                }
            )
        },
        emitNewVariableList () {
            this.newVariableList = this.convertArrayToMap()
            this.$emit('input', this.newVariableList)
        }
    },
    watch: {
        'config': 'convertDataToPreview'
    }
}
</script>

<style scoped lang="scss">
.VariablesForm {
    flex: 1;

    .variable-item {
        margin-bottom: 8px;

        &:last-child {
            margin-bottom: 0 !important;
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            font-family: "open sans" !important;
            font-size: 14px !important;
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.operator {
    text-align: center;

    ::v-deep .v-select.v-text-field input {
        display: none !important;
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field .v-input__append-inner {
        display: none;
    }

    .v-select__selection--comma {
        margin: 0 !important;
    }

    .v-select__selections {
        justify-content: center;
    }
}
</style>
